import { apiFetch } from 'modules/shared/fetch';
import { createCorrelationId } from 'utils/createUniqueId';
import { OIDCRequestParams } from './oidc.types';

const correlationId = createCorrelationId();

class OIDCService {
  static async getOCIDRegistration({
    appToken,
    appEnvironment,
  }: OIDCRequestParams) {
    const response = await apiFetch('/oidc-registrations', {
      // @ts-ignore
      appEnvironment,
      headers: {
        'lean-app-token': appToken,
        'lean-correlation-id': correlationId,
      },
    });

    return response?.data;
  }

  static async register({ appToken, body, appEnvironment }: OIDCRequestParams) {
    const response = await apiFetch('/oidc-registrations', {
      // @ts-ignore
      method: 'POST',
      appEnvironment,
      headers: {
        'lean-app-token': appToken,
        'lean-correlation-id': correlationId,
      },
      body,
    });

    return response?.data;
  }

  static async validateOidcUrl(url: string) {
    try {
      const response = await fetch(url, { method: 'GET' });
      return response.status === 200;
    } catch (error) {
      return false;
    }
  }
}

export { OIDCService };
